<template>
    <ul>
        <li v-for="(rule, ruleIndex) in rules" class="defaultOptionsDiv">
            <div class="rule-label">{{ $t('Priority [x]').replace(/\[x]/g, rule.priority) }}</div>
            <icon-button v-if="rules.length > 1" icon="remove-icon" @click="removeRule(ruleIndex)" />
            <icon-button v-if="ruleIndex === rules.length - 1 && rules.length < 5" icon="add-icon" @click="addRule" />
            <ArrowUpBold v-if="rule.priority > 1" class="moveup" @click="moveRule(ruleIndex)" />
            <edit-interval :item="rule" :parameters="parameters" @input="(val) => updateRule(ruleIndex, val)" />
            <table>
                <tbody>
                    <tr v-for="(prop, propIndex) in rule.properties">
                        <td class="rulePropertyCell">
                            <cic-select
                                :options="propOptions"
                                :value="prop.property"
                                @input="(val) => updateProperty(ruleIndex, propIndex, 'property', val)"
                            />
                        </td>
                        <td class="ruleConditionCell">
                            <cic-select
                                :options="conditionOptions"
                                :value="prop.condition"
                                @input="(val) => updateProperty(ruleIndex, propIndex, 'condition', val)"
                            />
                        </td>
                        <td class="ruleValueCell">
                            <cic-textbox
                                :int-only="true"
                                :maxlength="2"
                                :value="prop.value"
                                @input="(val) => updateProperty(ruleIndex, propIndex, 'value', val)"
                            />
                        </td>
                        <td>
                            <icon-button
                                v-if="rule.properties.length > 1"
                                icon="remove-icon"
                                @click="removeProperty(ruleIndex, propIndex)"
                            />
                        </td>
                        <td>
                            <icon-button
                                v-if="propIndex === rule.properties.length - 1 && rule.properties.length < 5"
                                icon="add-icon"
                                @click="addProperty(ruleIndex)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </li>
    </ul>
</template>

<script>
    import { ArrowUpBold } from '@element-plus/icons-vue';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import IconButton from '@/components/controls/IconButton';
    import EditInterval from './EditInterval';

    export default {
        name: 'EditRuleSet',
        components: {
            ArrowUpBold,
            EditInterval,
            IconButton,
            CicSelect,
            CicTextbox,
        },
        props: {
            parameters: {
                type: Object,
                required: true,
            },
            rules: {
                type: Array,
                required: true,
            },
        },
        emits: ['input'],
        data() {
            return {
                propOptions: [
                    { value: 'Age (Hours)', label: this.$t('Age (Hours)') },
                    { value: 'Age (Days)', label: this.$t('Age (Days)') },
                    { value: 'Age (Months)', label: this.$t('Age (Months)') },
                    {
                        value: 'Processing Attempts',
                        label: this.$t('Processing Attempts'),
                    },
                ],
                conditionOptions: [
                    { value: '=', label: '=' },
                    { value: '<', label: '<' },
                    { value: '>=', label: '>=' },
                ],
            };
        },
        methods: {
            addRule() {
                let rules = JSON.parse(JSON.stringify(this.rules));
                rules.push({
                    intervalType: 0,
                    intervalMS: 1,
                    intervalSessions: 0,
                    retryDate: null,
                    retryTime: null,
                    priority: rules.length + 1,
                    properties: [
                        {
                            property: 'Age (Hours)',
                            condition: '=',
                            value: '',
                        },
                    ],
                });
                this.$emit('input', rules);
            },
            moveRule(index) {
                let rules = JSON.parse(JSON.stringify(this.rules));
                rules.splice(index - 1, 0, rules.splice(index, 1)[0]);
                rules.forEach((x, ruleIndex) => {
                    x.priority = ruleIndex + 1;
                });
                this.$emit('input', rules);
            },
            removeRule(index) {
                let rules = JSON.parse(JSON.stringify(this.rules));
                rules.splice(index, 1);
                rules.forEach((x, ruleIndex) => {
                    x.priority = ruleIndex + 1;
                });
                this.$emit('input', rules);
            },
            updateRule(index, val) {
                let rules = JSON.parse(JSON.stringify(this.rules));
                val.forEach((x) => (rules[index][x.field] = x.value));
                this.$emit('input', rules);
            },

            addProperty(ruleIndex) {
                let rules = JSON.parse(JSON.stringify(this.rules));
                rules[ruleIndex].properties.push({
                    property: 'Age (Hours)',
                    condition: '=',
                    value: '',
                });
                this.$emit('input', rules);
            },
            removeProperty(ruleIndex, index) {
                let rules = JSON.parse(JSON.stringify(this.rules));
                rules[ruleIndex].properties.splice(index, 1);
                this.$emit('input', rules);
            },
            updateProperty(ruleIndex, index, field, val) {
                let rules = JSON.parse(JSON.stringify(this.rules));
                rules[ruleIndex].properties[index][field] = val;
                this.$emit('input', rules);
            },
        },
    };
</script>
